import { gql } from "@apollo/client";

export const CREATE_REASON = gql`
    mutation createReason($data: CreateReasonInput!) {
        createReason(data: $data) {
            id
            name
        }
    }
`;

export const UPDATE_REASON = gql`
    mutation updateReason($data: UpdateReasonInput!) {
        updateReason(data: $data) {
            id
            name
        }
    }
`;

export default CREATE_REASON;
